import React from 'react';
import OptimizedImage from '@/components/OptimizedImage';
import vormenLos11 from '@/assets/vormen los/Vormen los-11.webp';

interface GeoPatternProps {
  opacity?: number;
  visible?: boolean;
}

/**
 * GeoPattern component - adds geometric pattern overlay
 */
const GeoPattern: React.FC<GeoPatternProps> = ({ opacity = 0.3, visible = true }) => {
  if (!visible) return null;
  
  return (
    <div className="absolute inset-0 overflow-visible pointer-events-none z-0" style={{ opacity }}>
      {/* Centraal logo dat langzaam in alle richtingen beweegt */}
      <div className="absolute top-[40%] left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-35 animate-float-slow-all origin-center">
        <OptimizedImage 
          src={vormenLos11} 
          webpSrc={vormenLos11}
          alt=""
          aria-hidden="true"
          className="w-[400px] h-[400px] md:w-[600px] md:h-[600px] lg:w-[800px] lg:h-[800px] object-cover"
          width={800}
          height={800}
        />
      </div>
      
      {/* Vertical line - keeping as is */}
      <div className="absolute top-[20%] left-1/2 w-[1px] h-full bg-[#854C73] opacity-20"></div>
    </div>
  );
};

export default GeoPattern;

